export default [
  {
    path: '/ticket/my_ticket',
    name: 'my_ticket',
    component: () => import('@/components/menus/ticket/pages/my_ticket')
  },
  {
    path: '/ticket/list',
    name: 'ticket_list',
    component: () => import('@/components/menus/ticket/pages/ticket_list')
  },
  {
    path: '/ticket/update_list',
    name: 'update_list',
    component: () => import('@/components/menus/ticket/pages/update_list')
  },
  {
    path: '/ticket/completed_list',
    name: 'completed_list',
    component: () => import('@/components/menus/ticket/pages/completed_list')
  },
  {
    path: '/ticket/task_type',
    name: 'task_type',
    component: () => import('@/components/menus/ticket/pages/task_type')
  },
  {
    path: '/ticket/management',
    name: 'ticket_management',
    component: () => import('@/components/menus/ticket/ticket_management')
  },
  {
    path: '/ticket/dashboard',
    name: 'ticket_dashboard',
    component: () => import('@/components/menus/ticket/ticket_dashboard')
  },
  {
    path: '/ticket/statistics',
    name: 'ticket_statistics',
    component: () => import('@/components/menus/ticket/pages/ticket_statistics')
  },
  {
    path: '/ticket/ticket_create',
    name: 'ticket_create',
    component: () => import('@/components/menus/ticket/ticket_create')
  },
  {
    path: '/ticket/list/ticket_create',
    name: 'ticket_list_create',
    component: () => import('@/components/menus/ticket/ticket_create')
  },
  {
    path: '/ticket/ticket_details',
    name: 'ticket_details',
    component: () => import('@/components/menus/ticket/ticket_details')
  },
  {
    path: '/ticket/list/ticket_details',
    name: 'ticket_list_details',
    component: () => import('@/components/menus/ticket/ticket_details')
  },
  {
    path: '/operation/ticket',
    name: 'operation_ticket',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/operation/fragments/right/operation_ticket_details')
  },
  {
    path: '/system/ticket_brand/management',
    name: 'ticket_brand_management',
    component: () => import('@/components/menus/system/ticket_brand_management')
  },
  {
    path: '/system/ticket_brand/mapping',
    name: 'ticket_brand_mapping',
    component: () => import('@/components/menus/system/ticket_brand_mapping')
  },
  {
    path: '/system/ticket_task_type_management',
    name: 'task_type_management',
    component: () => import('@/components/menus/system/task_type_management')
  },
  {
    path: '/system/ticket_event_management',
    name: 'ticket_event_management',
    component: () => import('@/components/menus/system/ticket_event_management')
  },
  {
    path: '/ticket/reopen/chat',
    name: 'ticket_reopen_chat',
    meta: {
      requiresAuth: false
    },
    component: () => import('../../components/menus/ticket/ticket_reopen_chat'),
    props: (route) => ({
      ticketId: route.query.ticketId
    })
  },
  {
    path: '/agent/reservation/ticket',
    name: 'agent_reservation_ticket',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/views/agent/components/reservationTicketDetails')
  }
]



// WEBPACK FOOTER //
// ./src/router/subRoutes/ticketRouter.js